import { createAction, props } from '@ngrx/store';
import {
  BudgetVsCommitGeneralCashflow,
  BudgetVsCommitProjectCashflow,
  BudgetVsPrimeGeneralCashflow,
  BudgetVsPrimeProjectCashflow,
  CASHFLOW_TYPES,
  CashflowFilters,
  PrimeVsCommitGeneralCashflow,
  PrimeVsCommitProjectCashflow,
} from '../../framework/cash-flow/cashflow-table/cashflow.types';

const filtersChanged = createAction(
  '[Cashflow] Filters Changed',
  props<{ filters?: Partial<CashflowFilters>; cashflowType?: CASHFLOW_TYPES }>(),
);

const loadBudgetVsCommitGeneral = createAction(
  '[Cashflow] Load Budget VS Commitments General',
  props<{ filters: CashflowFilters }>(),
);
const budgetVsCommitGeneralLoadedSuccess = createAction(
  '[Cashflow] Cashflow Budget VS Commitments Loaded',
  props<{ data: BudgetVsCommitGeneralCashflow }>(),
);
const budgetVsCommitGeneralLoadedError = createAction(
  '[Cashflow] Error Loading Cashflow Budget VS Commitments',
  props<{ error: any }>(),
);

const loadBudgetVsCommitByProject = createAction(
  '[Cashflow] Load Budget VS Commitments By Project',
  props<{ filters: CashflowFilters }>(),
);
const budgetVsCommitByProjectLoadedSuccess = createAction(
  '[Cashflow] Project Cashflow Budget VS Commitments Loaded',
  props<{ projectId: number; data: BudgetVsCommitProjectCashflow }>(),
);
const budgetVsCommitByProjectLoadedError = createAction(
  '[Cashflow] Error Loading Project Cashflow Budget VS Commitments',
  props<{ error: any }>(),
);

const loadBudgetVsPrimeGeneral = createAction(
  '[Cashflow] Load Budget VS Prime General',
  props<{ filters: CashflowFilters }>(),
);
const budgetVsPrimeGeneralLoadedSuccess = createAction(
  '[Cashflow] Cashflow Budget VS Prime Loaded',
  props<{ data: BudgetVsPrimeGeneralCashflow }>(),
);
const budgetVsPrimeGeneralLoadedError = createAction(
  '[Cashflow] Error Loading Cashflow Budget VS Prime',
  props<{ error: any }>(),
);

const loadBudgetVsPrimeByProject = createAction(
  '[Cashflow] Load Budget VS Prime By Project',
  props<{ filters: CashflowFilters }>(),
);
const budgetVsPrimeByProjectLoadedSuccess = createAction(
  '[Cashflow] Project Cashflow Budget VS Prime Loaded',
  props<{ projectId: number; data: BudgetVsPrimeProjectCashflow }>(),
);
const budgetVsPrimeByProjectLoadedError = createAction(
  '[Cashflow] Error Loading Project Cashflow Budget VS Prime',
  props<{ error: any }>(),
);

const loadPrimeVsCommitGeneral = createAction(
  '[Cashflow] Load Prime VS Commitments General',
  props<{ filters: CashflowFilters }>(),
);
const primeVsCommitGeneralLoadedSuccess = createAction(
  '[Cashflow] Cashflow Prime VS Commitments Loaded',
  props<{ data: PrimeVsCommitGeneralCashflow }>(),
);
const primeVsCommitGeneralLoadedError = createAction(
  '[Cashflow] Error Loading Cashflow Prime VS Commitments',
  props<{ error: any }>(),
);

const loadPrimeVsCommitByProject = createAction(
  '[Cashflow] Load Prime VS Commitments By Project',
  props<{ filters: CashflowFilters }>(),
);
const primeVsCommitByProjectLoadedSuccess = createAction(
  '[Cashflow] Project Cashflow Prime VS Commitments Loaded',
  props<{ projectId: number; data: PrimeVsCommitProjectCashflow }>(),
);
const primeVsCommitByProjectLoadedError = createAction(
  '[Cashflow] Error Loading Project Cashflow Prime VS Commitments',
  props<{ error: any }>(),
);

const updateReportingSuccess = createAction('[Cashflow] Successfully Updated Reporting');

export const cashflowActions = {
  filtersChanged,
  loadBudgetVsCommitGeneral,
  budgetVsCommitGeneralLoadedSuccess,
  budgetVsCommitGeneralLoadedError,
  loadBudgetVsCommitByProject,
  budgetVsCommitByProjectLoadedSuccess,
  budgetVsCommitByProjectLoadedError,
  loadBudgetVsPrimeGeneral,
  budgetVsPrimeGeneralLoadedSuccess,
  budgetVsPrimeGeneralLoadedError,
  loadBudgetVsPrimeByProject,
  budgetVsPrimeByProjectLoadedSuccess,
  budgetVsPrimeByProjectLoadedError,
  loadPrimeVsCommitGeneral,
  primeVsCommitGeneralLoadedSuccess,
  primeVsCommitGeneralLoadedError,
  loadPrimeVsCommitByProject,
  primeVsCommitByProjectLoadedSuccess,
  primeVsCommitByProjectLoadedError,
  updateReportingSuccess,
};
